module.exports = __webpack_public_path__ + "static/media/bg-white.227cf223.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Hotel/images/bg-white.jpg
// module id = 646
// module chunks = 6